import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getStudent } from '../actions/studentActions';
import StudentProfile from '../components/student/StudentProfile';
import StudentProfileMenu from '../components/student/StudentProfileMenu';

class StudentProfilePage extends Component {
  componentWillMount() {
    const { id } = this.props.match.params;
    const { getStudent } = this.props;
    getStudent(id);
  }

  render() {
    const { view } = this.props.match.params;
    const { student, loading } = this.props;

    return (
      <div id="student-profile-page">
        { !loading &&
          <StudentProfileMenu
            student={student}
            view={view}
          />
        }
        { !loading &&
          <StudentProfile
            student={student}
            view={view}
          />
        }
      </div>
    );
  }
}

const { object, bool, func } = PropTypes;

StudentProfilePage.propTypes = {
  getStudent: func.isRequired,
  student: object.isRequired,
  match: object.isRequired,
  loading: bool.isRequired
};

const mapState = state => ({
  student: state.getIn(['student', 'student']).toJS(),
  loading: state.getIn(['student', 'loading'])
});

const mapDispatch = dispatch => ({
  getStudent: id => dispatch(getStudent(id))
});

export default connect(mapState, mapDispatch)(StudentProfilePage);



// WEBPACK FOOTER //
// ./src/containers/StudentProfilePage.js